import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiOutlineHome, AiOutlineShoppingCart, AiOutlineInfoCircle, AiOutlineMail, AiOutlineUser } from 'react-icons/ai';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo">
          <img src="/assets/images/logo.png" alt="Muktankar Traders Logo" />
          <span>ಮುಕ್ತಂಕಾರ ಟ್ರೇಡರ್ಸ್</span>
        </Link>

        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
            <AiOutlineHome />
            <span>ಮುಖಪುಟ</span>
          </Link>
          <Link to="/products" className={location.pathname === '/products' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
            <AiOutlineShoppingCart />
            <span>ಉತ್ಪನ್ನಗಳು</span>
          </Link>
          <Link to="/about" className={location.pathname === '/about' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
            <AiOutlineInfoCircle />
            <span>ನಮ್ಮ ಬಗ್ಗೆ</span>
          </Link>
          <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>
            <AiOutlineMail />
            <span>ಸಂಪರ್ಕಿಸಿ</span>
          </Link>
          <Link to="/login" className={`mobile-login ${location.pathname === '/login' ? 'active' : ''}`} onClick={() => setIsMenuOpen(false)}>
            <AiOutlineUser />
            <span>Login</span>
          </Link>
        </div>

        <div className="nav-actions">
          <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 